import { memo } from 'react';
import { useUserPresenceListeners } from '@/features/user/hooks/websocket/use-user-presence-listeners';
import { useSocketContext } from '@/websockets/contexts/socket.context';
import useNotificationSocketListeners from '@/features/notifications/websocket/use-notification-socket-listeners';
import { useCaseSocketListeners } from '@/features/cases/_shared/websocket/use-case-socket-listeners';
import { useSpaceUpdateSocketListeners } from '@/features/ticketings/_shared/websockets/use-space-update-socket-listener';

export interface ISocketEventListenersProviderProps {
  children: React.ReactNode;
}

const SocketEventListenersProvider = memo(({ children }: ISocketEventListenersProviderProps) => {
  const { socket } = useSocketContext();

  // Initialize all socket listeners
  // Each hook handles its own cleanup via useEffect return functions
  // Note: No isMounted needed here - these hooks handle their own cleanup internally
  useCaseSocketListeners(socket);
  useUserPresenceListeners(socket);
  useNotificationSocketListeners(socket);
  useSpaceUpdateSocketListeners(socket);

  return <>{children}</>;
});

SocketEventListenersProvider.displayName = 'SocketEventListenersProvider';

export default SocketEventListenersProvider;
